import React from "react";
import { useTranslate } from "@refinedev/core";
import { AlertCard } from "@libertify/ui";
import { Flex, theme, Typography } from "antd";
import { AnalyticsCard } from "../AnalyticsCard";
import { formatPct } from "../utils/formatPct";
import type { QuizEffect } from "./utils/metrics";

const T_PREFIX = "media.projects.analytics.addons";

/** null effect: the preparation request failed. */
export type QuizEffectCardProps = { effect: QuizEffect | null };

export const QuizEffectCard: React.FC<QuizEffectCardProps> = ({ effect }) => {
  const t = useTranslate();
  const { token } = theme.useToken();
  const card = (children: React.ReactNode) => (
    <AnalyticsCard
      title={t(`${T_PREFIX}.effect.title`)}
      subtitle={t(`${T_PREFIX}.effect.subtitle`)}
      info={t(`${T_PREFIX}.effect.info`)}
    >
      {children}
    </AnalyticsCard>
  );
  if (!effect)
    return card(<AlertCard type="error" title={t(`${T_PREFIX}.loadError`)} />);
  const good = effect.lift >= 8 && !effect.low;
  return card(
    <Flex vertical gap={12}>
      <div>
        <Typography.Text
          style={{ fontSize: token.fontSizeHeading2, fontWeight: 500 }}
        >
          {formatPct(effect.avg)}
        </Typography.Text>{" "}
        <Typography.Text type={good ? "success" : "secondary"}>
          {t(`${T_PREFIX}.effect.points`, {
            value: `${effect.lift >= 0 ? "+" : ""}${effect.lift}`,
          })}
        </Typography.Text>
        <Typography.Text
          type="secondary"
          style={{ display: "block", fontSize: token.fontSizeSM }}
        >
          {t(`${T_PREFIX}.effect.versus`, {
            baseline: formatPct(effect.baseline),
            count: effect.viewers,
            baselineViewers: effect.baselineViewers,
          })}
        </Typography.Text>
      </div>
    </Flex>
  );
};
